import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Grid, Row, Col, Button} from 'react-bootstrap'
import AddFeature from './AddFeature/AddFeature'
import showToastr from '../../utils/showToastr'
import FeatureComponent from './FeatureComponent'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import InfoNotification from '../Common/InfoNotification/InfoNotification'

import './Layout/Feature.css'

class FeatureScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      page: 1,
      data: [],
      activeNextPage: false,
      isAddFeatureBoxVisible: false,
      isLoading: true
    }

    this.loadNextPage = this.loadNextPage.bind(this)
    this.addFeatureHandler = this.addFeatureHandler.bind(this)
    this.getList = this.getList.bind(this)
  }

  getList (appendResult = false) {
    Actions.featureList(this.state.page).then((res) => {
      this.setState({isLoading: false})

      if (res.data.length <= 10) {
        this.setState({activeNextPage: false})
      }

      if (!appendResult) {
        this.setState({data: res.data})
      } else {
        this.setState({data: [...this.state.data, res.data]})
      }
    })
  }

  componentWillMount () {
    if (this.props.list) {
      let data = this.props.list
      return this.setState({data: data, isLoading: false, activeNextPage: !!data.length})
    }
  }

  componentDidMount () {
    this.setState({isLoading: true})
    this.getList()
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.list) {
      return this.setState({data: nextProps.list, isLoading: false, activeNextPage: !!nextProps.list.length})
    }
  }

  loadNextPage () {
    if (this.state.activeNextPage) {
      this.setState({page: this.state.page + 1}, () => {
        this.getList(true)
      })
    }
  }

  addFeatureHandler (show = true) {
    const {auth} = this.props
    if (!auth.isAuthenticated) {
      showToastr('warning', 'امکان جدید', 'لازم است به حساب خود وارد شوید')
      Actions.toggleLoginBox(true)
      return undefined
    }
    this.setState({isAddFeatureBoxVisible: show})
  }

  render () {
    const { isLoading, activeNextPage, data, isAddFeatureBoxVisible } = this.state
    const { user, auth } = this.props
    return (
      <div id="feature-screen">
        <InfoNotification message="آموزش پیشنهاد تغییر در سایت" url="/page/help-add-new-feature" />
        <AddFeature isVisible={isAddFeatureBoxVisible} toggler={this.addFeatureHandler} />
        <Grid>
          <Row>
            <Col sm={10} smOffset={1} xs={12} xsOffset={0}>
              <Row className="title">
                <h2>ویژگی های جدید</h2>
                <p>
                  در این بخش ویژگی‌های جدیدی که به ذهن زیبایتان خطور می‌کند و تصور می‌کنید جای آن‌ها در ایاهو خالی است پیشنهاد دهید. پس از بررسی ویژگی‌ها امتیاز لازم برای آن‌ها مشخص می‌شود و شما می‌توانید با پخش کردن لینک آن امتیاز لازم برای پیاده‌سازی فوری آن را فراهم کنید.
                  در ضمن اگر ویژگی جالبی می بینید و دوست دارید زودتر به سایت اضافه شود، به آن نعل بدهید!
                </p>
                <Button onClick={() => this.addFeatureHandler(true)} bsStyle="info" className="add-feature">افزودن ویژگی جدید</Button>
              </Row>
              {isLoading ? <HorseLoading /> : <Row className="wrapper">
                {data && <Col xs={12}>
                  {data.map((item, index) => (
                    <FeatureComponent key={index} feature={item} user={user} isAuthenticated={auth.isAuthenticated} />
                  ))}
                  {activeNextPage && <Button className="more" bsStyle="info" onClick={this.loadNextPage} block>نمایش بیشتر...</Button>}
                </Col>}
              </Row>}
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

FeatureScreen.fetchData = ({location}) => {
  return Actions.featureList(location.query.page || 1).then((res) => {
    Actions.setFeatureList(res.data)
    return res
  })
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    user: state.user.currentUser,
    list: state.feature.list
  }
}

export default connect(mapStateToProps)(FeatureScreen)



// WEBPACK FOOTER //
// ./src/components/Feature/FeatureScreen.js